import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import mainHelper, {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockItemAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            parentCategories: [],
            subCategories: [],
            selectedParentId: '',
            formData : {
                name:'',
                sku:'',
                barcode:'',
                category_id:'',
                unit:'adet',
                description:'',
                min_stock_level:'0',
                max_stock_level:'',
                unit_price:'0',
                is_serialized: false,
                is_lot_tracked: false,
                is_active: true
            }
        }
    }

    componentDidMount() {
        this.fetchParentCategories();
    }

    fetchParentCategories = async () => {
        try {
            const response = await apiCall('business/stock/category/all?parent_only=true','get');
            this.setState({parentCategories: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    fetchSubCategories = async (parentId) => {
        if(!parentId) {
            this.setState({subCategories: [], selectedParentId: ''});
            return;
        }

        try {
            const response = await apiCall(`business/stock/category/all?parent_id=${parentId}`,'get');
            this.setState({
                subCategories: response.data || [],
                selectedParentId: parentId
            });
        } catch (e) {
            console.error(e);
            this.setState({subCategories: []});
        }
    }

    handleParentCategoryChange = (e) => {
        const parentId = e.target.value;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                category_id: '' // Alt kategori seçimi sıfırla
            }
        }));
        this.fetchSubCategories(parentId);
    }

    handleChange = (e) => {
        const {id,value,type,checked} = e.target;
        this.setState(prevState => ({
            formData : {
                ...prevState.formData,
                [id] : type === 'checkbox' ? checked : value
            }
        }))
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({loading:true});
        const {formData} = this.state;
        const itemFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            itemFormData.append(key,formData[key]);
        });

        try {
            const response = await apiCall('business/stock/item/add','post',itemFormData);
            this.setState({loading:false});
            mainHelper.toastMessage(response.status,response.message);
            if(response.status === 'success') {
                this.props.history.push('/stock/items');
            }
        }catch (e) {
            this.setState({loading:false});
        }
    }

    render() {
        const {loading, parentCategories, subCategories, selectedParentId, formData} = this.state;
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Stok Kalemi Ekle"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Stok Kalemleri", navigate: "stock/items" },
                                { name: "Yeni Stok Kalemi", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="card">
                                <form onSubmit={this.handleSubmit}>
                                    <div className="body">
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Ürün Adı *</label>
                                                    <input
                                                        id="name"
                                                        className="form-control"
                                                        placeholder="Ürün Adı"
                                                        type="text"
                                                        value={formData.name}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>SKU *</label>
                                                    <input
                                                        id="sku"
                                                        className="form-control"
                                                        placeholder="Stok Kodu"
                                                        type="text"
                                                        value={formData.sku}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Ana Kategori *</label>
                                                    <select
                                                        className="form-control"
                                                        value={selectedParentId}
                                                        onChange={this.handleParentCategoryChange}
                                                        required
                                                    >
                                                        <option value="">Ana Kategori Seçin</option>
                                                        {parentCategories.map(category => (
                                                            <option key={category.id} value={category.id}>
                                                                📁 {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <small className="form-text text-muted">
                                                        Önce ana kategori seçmelisiniz
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Alt Kategori *</label>
                                                    <select
                                                        id="category_id"
                                                        className="form-control"
                                                        value={formData.category_id}
                                                        onChange={this.handleChange}
                                                        disabled={!selectedParentId || subCategories.length === 0}
                                                        required
                                                    >
                                                        <option value="">
                                                            {!selectedParentId ? 'Önce Ana Kategori Seçin' :
                                                                subCategories.length === 0 ? 'Bu kategoride alt kategori yok' :
                                                                    'Alt Kategori Seçin'}
                                                        </option>
                                                        {subCategories.map(category => (
                                                            <option key={category.id} value={category.id}>
                                                                📄 {category.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <small className="form-text text-muted">
                                                        {selectedParentId && subCategories.length === 0 && (
                                                            <span className="text-warning">
                                                                ⚠️ Bu ana kategoride alt kategori bulunmuyor.
                                                                <a href="/stock/categories" className="ml-1"
                                                                   target="_blank">
                                                                    Alt kategori ekleyin
                                                                </a>
                                                            </span>
                                                        )}
                                                        {selectedParentId && subCategories.length > 0 && (
                                                            <span className="text-success">
                                                                ✓ {subCategories.length} alt kategori mevcut
                                                            </span>
                                                        )}
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Barkod</label>
                                                    <input
                                                        id="barcode"
                                                        className="form-control"
                                                        placeholder="Barkod"
                                                        type="text"
                                                        value={formData.barcode}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Birim *</label>
                                                    <select
                                                        id="unit"
                                                        className="form-control"
                                                        value={formData.unit}
                                                        onChange={this.handleChange}
                                                        required
                                                    >
                                                        <option value="adet">Adet</option>
                                                        <option value="kg">Kilogram (kg)</option>
                                                        <option value="gram">Gram (g)</option>
                                                        <option value="litre">Litre (L)</option>
                                                        <option value="metre">Metre (m)</option>
                                                        <option value="kutu">Kutu</option>
                                                        <option value="paket">Paket</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Birim Fiyat *</label>
                                                    <input
                                                        id="unit_price"
                                                        className="form-control"
                                                        placeholder="Birim Fiyat"
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.unit_price}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Minimum Stok Seviyesi *</label>
                                                    <input
                                                        id="min_stock_level"
                                                        className="form-control"
                                                        placeholder="Minimum Stok"
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.min_stock_level}
                                                        onChange={this.handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group">
                                                    <label>Maksimum Stok Seviyesi</label>
                                                    <input
                                                        id="max_stock_level"
                                                        className="form-control"
                                                        placeholder="Maksimum Stok"
                                                        type="number"
                                                        step="0.01"
                                                        value={formData.max_stock_level}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label>Açıklama</label>
                                                    <textarea
                                                        id="description"
                                                        className="form-control"
                                                        placeholder="Açıklama"
                                                        rows="3"
                                                        value={formData.description}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        <input
                                                            id="is_serialized"
                                                            type="checkbox"
                                                            checked={formData.is_serialized}
                                                            onChange={this.handleChange}
                                                        />
                                                        {' '}Seri Numarası Takibi
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        <input
                                                            id="is_lot_tracked"
                                                            type="checkbox"
                                                            checked={formData.is_lot_tracked}
                                                            onChange={this.handleChange}
                                                        />
                                                        {' '}Lot Numarası Takibi
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        <input
                                                            id="is_active"
                                                            type="checkbox"
                                                            checked={formData.is_active}
                                                            onChange={this.handleChange}
                                                        />
                                                        {' '}Aktif
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        <div className="row clearfix justify-content-center">
                                            <div className="col-lg-6 col-md-12">
                                                {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                                disabled={true}
                                                                style={{textAlign: "-webkit-center"}}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                                            height={'24px'}
                                                                                            color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                    <button className="btn btn-outline-primary btn-block" type="submit">
                                                        Kaydet
                                                    </button>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockItemAdd));

